import ReactGA from 'react-ga4';
import { API } from 'aws-amplify';
import { graphqlOperation, GraphQLResult } from '@aws-amplify/api-graphql';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { UpdateUserInput, User, UserBackend } from './users.interfaces';
import { userUpdateQuery } from './userUpdate.query';

export const updateUserThunk = createAsyncThunk(
  'user/updateUser',
  async (
    payload: {
      resourceChange: UpdateUserInput;
    },
    thunkApi,
  ): Promise<any> => {
    const { resourceChange } = payload;

    try {
      const result = (await API.graphql(
        graphqlOperation(userUpdateQuery, { input: resourceChange }),
      )) as GraphQLResult<{ updateUser: User }>;

      return translateResult(result, thunkApi);
    } catch (error) {
      return thunkApi.rejectWithValue({
        message: error,
      });
      // return thunkAPI.rejectWithValue({
      //   heading: 'Unable to update user',
      //   message: 'Unexpected error when updating user',
      //   severity: 'error',
      //   id: uuidv4(),
      // });
    }
  },
);

function translateResult(
  result: GraphQLResult<{ updateUser: User }>,
  thunkApi: any,
) {
  // QUESTION: do we need this check? Is it possible it succeeds but fail to return user?
  if (!result?.data) {
    return thunkApi.rejectWithValue({
      message: 'updateUser failed to return user',
    });
  }
  ReactGA.event({
    category: 'User',
    action: 'Update',
  });
  const appUser = result.data.updateUser;
  return appUser;
}
